import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

const setMultiSelectionAnchorRowKeyMutator: (
    tableView: TableView,
    newMultiSelectionAnchorRowKey: string | null
) => void = mutatorAction(
    'setMultiSelectionAnchorRowKey',
    function setMultiSelectionAnchorRowKey(
        tableView: TableView,
        newMultiSelectionAnchorRowKey: string | null
    ): void {
        tableView.multiSelectionAnchorRowKey = newMultiSelectionAnchorRowKey;
    }
);
export default setMultiSelectionAnchorRowKeyMutator;
